import { LitEntity, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-icon';
import './request-service-modal';

class RequestServiceButton extends LitEntity {
  static get properties() {
    return {
      showModal: { type: Boolean, attribute: false },
      hideWhenUnavailable: { type: Boolean, attribute: 'hide-when-unavailable' },
      fullWidth: { type: Boolean, attribute: 'full-width', reflect: true },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host([full-width]) {
        width: 100%;
      }
    `];
  }

  render() {
    const canCreateService = this.entity?.hasActionByName('generate-service-request');
    if (!canCreateService && this.hideWhenUnavailable) {
      return html``;
    }
    return html`
      <button
        title="Create Service Request"
        class="button button--contained"
        @click="${() => this.showModal = true}"
        ?disabled="${!canCreateService || this.loading || !this.entity}"
        ?full-width="${this.fullWidth}"
      >
        ${this.loading || !this.entity ? html`<bn-icon name="fas fa-spinner fa-pulse"></bn-icon>` : html`${this.title || 'Request Service'}`}
      </button>

      <request-service-modal
        .href="${this.href}"
        ?hide="${!this.showModal}"
        @close="${() => this.showModal = false}"
        @response="${({ detail }) => this.dispatchEvent(new CustomEvent('response', { detail, bubbles: true, composed: true }))}"
      ></request-service-modal>
    `;
  }
}

window.customElements.define('request-service-button', RequestServiceButton);
